// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3uo-g","infoBtn":"quickbooks_infoBtn__2inoP","formBox":"quickbooks_formBox__3Fwfm","formFooter":"quickbooks_formFooter__k77b7"};